// extracted by mini-css-extract-plugin
module.exports = {"how_works":"HowWorksNew_how_works__HXNkt"};